import React from 'react';
import { Route, Switch } from 'react-router-dom';
import AppRouter from './app/AppRouter';

const MainRouter = () => {
  return (
    <Switch>
      <Route path={'/'} component={AppRouter} />
    </Switch>
  );
};

export default MainRouter;
